import { compact, map, toLower, trim, uniq } from "lodash";
import { aiccInstance } from "utils/instance";
import {
  AiccTestAccountCandidateResponse,
  AiccTestAccountQuotaLimitResponse,
  AiccTestAccountResponse,
} from "types/dto/response/aiccTestAccount";
import {
  AddAiccTestAccountRequest,
  AiccTestAccountCandidateRequest,
  UpdateAiccTestAccountAccessRequest,
  UpdateAiccTestAccountQuotaLimitRequest,
} from "types/dto/request/aiccTestAccount";
import {
  transformAiccTestAccount,
  transformAiccTestAccountCandidateList,
  transformAiccTestAccountList,
} from "types/transformers/aiccTestAccount";

const TEST_ACCOUNTS_URL = "/test-accounts";

export async function searchAiccTestAccountCandidates(key: string, domains: string[]) {
  const request: AiccTestAccountCandidateRequest = {
    domain: uniq(compact(map(domains, (domain) => toLower(trim(domain))))),
    key: trim(key) || undefined,
  };
  return aiccInstance
    .post<AiccTestAccountCandidateResponse[]>(`${TEST_ACCOUNTS_URL}/candidates`, request)
    .then((response) => transformAiccTestAccountCandidateList(response));
}

export async function fetchAiccTestAccounts() {
  return aiccInstance
    .get<AiccTestAccountResponse[]>(TEST_ACCOUNTS_URL)
    .then((response) => transformAiccTestAccountList(response));
}

export async function addAiccTestAccount(customerId: string) {
  const request: AddAiccTestAccountRequest = { customer_id: customerId };
  return aiccInstance
    .post<AiccTestAccountResponse[]>(TEST_ACCOUNTS_URL, request)
    .then((response) => transformAiccTestAccountList(response));
}

export async function deleteAiccTestAccount(customerId: string) {
  return aiccInstance.delete<void>(`${TEST_ACCOUNTS_URL}/${customerId}`);
}

export async function updateAiccTestAccountQuota(customerId: string, messageQuota?: number) {
  const request: UpdateAiccTestAccountQuotaLimitRequest = { message_limit: messageQuota };
  return aiccInstance.put<AiccTestAccountQuotaLimitResponse>(`/quotas/${customerId}/preview/limit`, request);
}

export async function updateAiccTestAccountAccess(customerId: string, hasAccess: boolean) {
  const request: UpdateAiccTestAccountAccessRequest = { enabled: hasAccess };
  return aiccInstance
    .put<AiccTestAccountResponse>(`${TEST_ACCOUNTS_URL}/${customerId}/preview-access`, request)
    .then((response) => (response ? transformAiccTestAccount(response) : undefined));
}
